import { Component, EventEmitter, Output } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { BaseComponent } from '@portals/core';

@Component({
	selector: 'portals-flag',
	templateUrl: './flag.component.html',
	styleUrls: ['./flag.component.scss'],
})
export class FlagComponent extends BaseComponent {
	@Output() flag = new EventEmitter();

	constructor() {
		super();
	}

	onChange(state: MatSlideToggleChange) {
		this.flag.emit(state.checked);
	}
}
